import axios from "@configs/axios";
import { ENDPOINTS_BASE_URL, responsible } from "../utils/constants/apiRoutes";
import { LawsuitResponsible } from "@customTypes/user/responsible";

const getAllResponsibles = (tenantId: number | string) =>
  axios.get<never, { data: LawsuitResponsible[] }>(
    `${ENDPOINTS_BASE_URL}${responsible.BASE_URL}${responsible.ALL_USER}`,
    {
      params: { tenantId },
    }
  );

export default { getAllResponsibles };
